<div class="statusInfo px-2 d-flex flex-direction-column g-2">
  <div>
    <mat-chip-set aria-label="Distribution Health In Progress" class="status-chip chip-size-m discovery">
      <mat-chip>In Progress</mat-chip>
    </mat-chip-set>
    <div>At least one distributed job from the latest run is still running.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Distribution Health Healthy" class="status-chip chip-size-m success">
      <mat-chip>Healthy</mat-chip>
    </mat-chip-set>
    <div>All distributed jobs from the latest run succeeded.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Distribution Health Degraded" class="status-chip chip-size-m pending">
      <mat-chip>Degraded</mat-chip>
    </mat-chip-set>
    <div>Some distributed jobs from the latest run succeeded and some failed.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Distribution Health Failed" class="status-chip chip-size-m error">
      <mat-chip>Failed</mat-chip>
    </mat-chip-set>
    <div>All distributed jobs from the latest run failed.</div>
  </div>
</div>
